"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MAX_COMPETENCY_FRAMEWORK_SIZE () {
        return MAX_COMPETENCY_FRAMEWORK_SIZE;
    },
    get MAX_COMPETENCY_LEVELS () {
        return MAX_COMPETENCY_LEVELS;
    },
    get MAX_COMPETENCY_NAME_LENGTH () {
        return MAX_COMPETENCY_NAME_LENGTH;
    },
    get MAX_ROLE_NAME_LENGTH () {
        return MAX_ROLE_NAME_LENGTH;
    }
});
const MAX_COMPETENCY_LEVELS = 5;
const MAX_COMPETENCY_NAME_LENGTH = 250;
const MAX_ROLE_NAME_LENGTH = 250;
const MAX_COMPETENCY_FRAMEWORK_SIZE = 12;
